let currencyCode = 'usd';

export function setCurrency(value: string) {
  currencyCode = value;
}

export function getCurrency() {
  return currencyCode;
}

export function currency(value: number, decimals = 0, currencyCodeOverride = '') {
  if (!Number.isFinite(value)) return '$-';
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCodeOverride || currencyCode,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return formatter.format(value);
}

export function currencyInCents(value: number, decimals = 2, currencyCodeOverride = '') {
  return currency(value / 100, decimals, currencyCodeOverride);
}

/**
 * Formats an amountInCents into a human readable value with the proper prefix
 * followed by the amount converted to dollars (or equivalent)
 */
export function formatCurrencyCents(currency: string, cents: number) {
  const numFormat = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return getCurrencyPrefix(currency) + numFormat.format(cents / 100);
}

/**
 * Returns the symbol like $ or €
 */
function getCurrencySymbol(currency: string, locale = 'en') {
  return (0).toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).replace(/\d/g, '').trim();
}

/**
 * Returns the full prefix, eg USD$ or CA$ or EUR€
 */
export function getCurrencyPrefix(currency: string): string {
  const symbol = getCurrencySymbol(currency);
  if (currency !== 'usd') {
    return symbol;
  }
  return currency + symbol;
}
